import { DestroyRef, inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { saveAs } from '@shared/utils/download.util';

@Injectable()
export class DownloadPdfService {
  private readonly _httpClient = inject(HttpClient);
  private readonly _destroyRef = inject(DestroyRef);

  downloadPdf(url: string) {
    this._httpClient
      .get(url, { responseType: 'blob' })
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe({
        next: (data) => {
          saveAs(data, 'document.pdf');
        },
      });
  }
}
